import { GraphQLQueryClass } from "@bsm/component";
import { TBankInformation, TBankInformationResponse } from "@bsm/graphql";

export class BanksQuery implements GraphQLQueryClass<TBankInformationResponse, TResponse> {
    public queryKey: string = "App.Bsm.BanksQuery";
    public gql: string = `
        query BanksQuery(
            $key: String
            $pageSize: Float,
            $page: Float,
            $data: JSONObject
            $sort: [TFilterSort!]
        ){
            bankInformations(filter: {
                key: $key
                data: $data,
                pageSize: $pageSize,
                page: $page,
                sort: $sort
            }) {
                total
                data {
                    id
                    bankName
                    bankAdress
                    iban
                    currency
                    isEditable
                    isDeletable
                }
            }
        }
    `;
    variables?: any;

    constructor(variables: any) {
        this.variables = variables;
    }
    mapFn(data: TResponse): TBankInformationResponse {
        return {
            total: data.bankInformations.total,
            data: data.bankInformations.data,
        };
    }
}

export type TResponse = {
    bankInformations: {
        total: number;
        data: Array<TBankInformation>;
    };
};
